import Toggle from '../../functions/toggle'

/**
 * Extend toggle with breakpoint
 * @extends Toggle
 */
export default class Navigation extends Toggle {
  /**
   * Initialize navigation
   */
  init () {
    super.init()

    if (this.config.breakpoint.matches) {
      for (let i = 0; i < this.config.trigger.length; i++) {
        this.config.trigger[i].setAttribute('aria-expanded', 'true')
      }

      this.config.target.setAttribute('aria-hidden', 'false')
    } else {
      for (let i = 0; i < this.config.trigger.length; i++) {
        this.config.trigger[i].setAttribute('aria-expanded', 'false')
      }

      this.config.target.setAttribute('aria-hidden', 'true')
    }

    this.config.breakpoint.addListener(event => {
      if (event.matches) {
        this.close()

        for (let i = 0; i < this.config.trigger.length; i++) {
          this.config.trigger[i].setAttribute('aria-expanded', 'true')
        }

        this.config.target.setAttribute('aria-hidden', 'false')
      } else {
        for (let i = 0; i < this.config.trigger.length; i++) {
          this.config.trigger[i].setAttribute('aria-expanded', 'false')
        }

        this.config.target.setAttribute('aria-hidden', 'true')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.js